import Heading from '@components/Heading/Heading';
import { IPageBigHeader, IPageHeaderBlock, IPageSimpleHeader, IPageSmallHeader } from '@features/cms/typescript';
import styles from '@features/pages/components/PagesAccordion/PagesAccordion.styles';
import sanitizeHtml from '@utils/sanitizeHtml';
type PropsType = {
  data: IPageHeaderBlock<IPageSimpleHeader | IPageSmallHeader | IPageBigHeader>;
  isFirst?: boolean;
};
const PagesAccordionHeader = ({
  data,
  isFirst = false
}: PropsType) => {
  const {
    headerType,
    headerData
  } = data;
  if (headerType === 'simple') {
    const {
      header
    } = headerData as IPageSimpleHeader;
    return <div sx={styles.headerBlockWrapper}>
        <div sx={styles.headerBlockContent}>
          <Heading h={isFirst ? 1 : 2} display={3} mobile>
            {header}
          </Heading>
        </div>
      </div>;
  }
  if (headerType === 'small') {
    const {
      header,
      subHeader
    } = headerData as IPageSmallHeader;
    const subHeaderHtml = sanitizeHtml(subHeader);
    return <div sx={styles.headerBlockWrapper}>
        <div sx={styles.headerBlockContent}>
          <Heading h={isFirst ? 1 : 2} display={3} pb={24} mobile>
            {header}
          </Heading>
          <p dangerouslySetInnerHTML={subHeaderHtml} />
        </div>
      </div>;
  }
  if (headerType === 'big') {
    const {
      subHeader
    } = headerData as IPageBigHeader;
    const subHeaderHtml = sanitizeHtml(subHeader);
    return <div sx={styles.headerBlockWrapper}>
        <div sx={styles.headerBlockContent}>
          <Heading h={isFirst ? 1 : 2} headingType={3} mobile>
            <span dangerouslySetInnerHTML={subHeaderHtml} />
          </Heading>
        </div>
      </div>;
  }
  return null;
};
export default PagesAccordionHeader;